// NBA team name to ESPN logo mapping
const NBA_TEAMS = {
  // Full names
  'Atlanta Hawks': 'atl',
  'Boston Celtics': 'bos',
  'Brooklyn Nets': 'bkn',
  'Charlotte Hornets': 'cha',
  'Chicago Bulls': 'chi',
  'Cleveland Cavaliers': 'cle',
  'Dallas Mavericks': 'dal',
  'Denver Nuggets': 'den',
  'Detroit Pistons': 'det',
  'Golden State Warriors': 'gs',
  'Houston Rockets': 'hou',
  'Indiana Pacers': 'ind',
  'LA Clippers': 'lac',
  'Los Angeles Clippers': 'lac',
  'LA Lakers': 'lal',
  'Los Angeles Lakers': 'lal',
  'Memphis Grizzlies': 'mem',
  'Miami Heat': 'mia',
  'Milwaukee Bucks': 'mil',
  'Minnesota Timberwolves': 'min',
  'New Orleans Pelicans': 'no',
  'New York Knicks': 'ny',
  'Oklahoma City Thunder': 'okc',
  'Orlando Magic': 'orl',
  'Philadelphia 76ers': 'phi',
  'Phoenix Suns': 'phx',
  'Portland Trail Blazers': 'por',
  'Sacramento Kings': 'sac',
  'San Antonio Spurs': 'sa',
  'Toronto Raptors': 'tor',
  'Utah Jazz': 'utah',
  'Washington Wizards': 'wsh',
  // Short names
  'Hawks': 'atl',
  'Celtics': 'bos',
  'Nets': 'bkn',
  'Hornets': 'cha',
  'Bulls': 'chi',
  'Cavaliers': 'cle',
  'Mavericks': 'dal',
  'Nuggets': 'den',
  'Pistons': 'det',
  'Warriors': 'gs',
  'Rockets': 'hou',
  'Pacers': 'ind',
  'Clippers': 'lac',
  'Lakers': 'lal',
  'Grizzlies': 'mem',
  'Heat': 'mia',
  'Bucks': 'mil',
  'Timberwolves': 'min',
  'Pelicans': 'no',
  'Knicks': 'ny',
  'Thunder': 'okc',
  'Magic': 'orl',
  '76ers': 'phi',
  'Suns': 'phx',
  'Trail Blazers': 'por',
  'Kings': 'sac',
  'Spurs': 'sa',
  'Raptors': 'tor',
  'Jazz': 'utah',
  'Wizards': 'wsh',
};

// Get team abbreviation from name
function getTeamAbbr(teamName) {
  if (!teamName) return null;
  
  // Direct match
  if (NBA_TEAMS[teamName]) {
    return NBA_TEAMS[teamName];
  }
  
  // Partial match
  for (const [name, abbr] of Object.entries(NBA_TEAMS)) {
    if (teamName.toLowerCase().includes(name.toLowerCase()) ||
        name.toLowerCase().includes(teamName.toLowerCase())) {
      return abbr;
    }
  }
  
  return null;
}

// Get ESPN logo URL for a team
export function getTeamLogo(teamName, size = 100) {
  const abbr = getTeamAbbr(teamName);
  if (!abbr) {
    // Return a placeholder
    return `https://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/nba.png&h=${size}&w=${size}`;
  }
  return `https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/${abbr}.png&h=${size}&w=${size}`;
}

export default getTeamLogo;
